import { jsx } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import isEqual from "lodash/isEqual";
import { useField } from "react-final-form";
import { MultipleAutocompleteInput } from "@vk-hr-tek/ui/input";
import { compose } from "../validation/index.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function MultipleAutocompleteInput_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else MultipleAutocompleteInput_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
const handleChange = (input, onChange)=>(value)=>{
        input.onChange(value);
        null == onChange || onChange(value);
    };
const MultipleAutocompleteInput_MultipleAutocompleteInput = (props)=>{
    const $ = c(58);
    const { label, labelIcon, onChange, tooltip, name, placeholder, required, loading, limit, disabledTooltip, disabled, clearable, validate: t0, helperText, minInputValueLength, renderTags, renderOption, testId, withoutMargin: t1, validationWithoutTouch: t2, validationWhenDisabled: t3 } = props;
    let t4;
    if ($[0] !== t0) {
        t4 = void 0 === t0 ? [] : t0;
        $[0] = t0;
        $[1] = t4;
    } else t4 = $[1];
    const validate = t4;
    const withoutMargin = void 0 === t1 ? false : t1;
    const validationWithoutTouch = void 0 === t2 ? false : t2;
    const validationWhenDisabled = void 0 === t3 ? false : t3;
    let t5;
    if ($[2] !== validate) {
        t5 = compose(validate);
        $[2] = validate;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== t5) {
        t6 = {
            validate: t5,
            isEqual: isEqual
        };
        $[4] = t5;
        $[5] = t6;
    } else t6 = $[5];
    const { input, meta } = useField(name, t6);
    const errorDisabled = disabled || !validationWhenDisabled;
    const renderError = !errorDisabled && validationWithoutTouch ? !!input.value && !!meta.error : meta.touched && !!meta.error;
    if ("load" === props.type) {
        const t7 = props.type;
        let t8;
        if ($[6] !== input || $[7] !== onChange) {
            t8 = handleChange(input, onChange);
            $[6] = input;
            $[7] = onChange;
            $[8] = t8;
        } else t8 = $[8];
        const t9 = renderError && meta.error || helperText;
        let t10;
        if ($[9] !== clearable || $[10] !== disabled || $[11] !== disabledTooltip || $[12] !== input || $[13] !== label || $[14] !== labelIcon || $[15] !== limit || $[16] !== loading || $[17] !== minInputValueLength || $[18] !== placeholder || $[19] !== props.loadItems || $[20] !== props.type || $[21] !== renderError || $[22] !== renderOption || $[23] !== renderTags || $[24] !== required || $[25] !== t8 || $[26] !== t9 || $[27] !== testId || $[28] !== tooltip || $[29] !== withoutMargin) {
            t10 = /*#__PURE__*/ jsx(MultipleAutocompleteInput, _object_spread_props(_object_spread({}, input), {
                type: t7,
                label: label,
                labelIcon: labelIcon,
                onChange: t8,
                loading: loading,
                tooltip: tooltip,
                placeholder: placeholder,
                required: required,
                limit: limit,
                disabledTooltip: disabledTooltip,
                disabled: disabled,
                clearable: clearable,
                error: renderError,
                helperText: t9,
                loadItems: props.loadItems,
                minInputValueLength: minInputValueLength,
                renderTags: renderTags,
                renderOption: renderOption,
                testId: testId,
                withoutMargin: withoutMargin
            }));
            $[9] = clearable;
            $[10] = disabled;
            $[11] = disabledTooltip;
            $[12] = input;
            $[13] = label;
            $[14] = labelIcon;
            $[15] = limit;
            $[16] = loading;
            $[17] = minInputValueLength;
            $[18] = placeholder;
            $[19] = props.loadItems;
            $[20] = props.type;
            $[21] = renderError;
            $[22] = renderOption;
            $[23] = renderTags;
            $[24] = required;
            $[25] = t8;
            $[26] = t9;
            $[27] = testId;
            $[28] = tooltip;
            $[29] = withoutMargin;
            $[30] = t10;
        } else t10 = $[30];
        return t10;
    }
    const t7 = props.type;
    let t8;
    if ($[31] !== input || $[32] !== onChange) {
        t8 = handleChange(input, onChange);
        $[31] = input;
        $[32] = onChange;
        $[33] = t8;
    } else t8 = $[33];
    const t9 = renderError && meta.error || helperText;
    let t10;
    if ($[34] !== clearable || $[35] !== disabled || $[36] !== disabledTooltip || $[37] !== input || $[38] !== label || $[39] !== labelIcon || $[40] !== limit || $[41] !== loading || $[42] !== minInputValueLength || $[43] !== placeholder || $[44] !== props.allowSelectAll || $[45] !== props.externalItems || $[46] !== props.selectAllLabel || $[47] !== props.type || $[48] !== renderError || $[49] !== renderOption || $[50] !== renderTags || $[51] !== required || $[52] !== t8 || $[53] !== t9 || $[54] !== testId || $[55] !== tooltip || $[56] !== withoutMargin) {
        t10 = /*#__PURE__*/ jsx(MultipleAutocompleteInput, _object_spread_props(_object_spread({}, input), {
            type: t7,
            label: label,
            labelIcon: labelIcon,
            onChange: t8,
            loading: loading,
            tooltip: tooltip,
            placeholder: placeholder,
            required: required,
            limit: limit,
            disabledTooltip: disabledTooltip,
            disabled: disabled,
            clearable: clearable,
            error: renderError,
            helperText: t9,
            externalItems: props.externalItems,
            selectAllLabel: props.selectAllLabel,
            allowSelectAll: props.allowSelectAll,
            minInputValueLength: minInputValueLength,
            renderTags: renderTags,
            renderOption: renderOption,
            testId: testId,
            withoutMargin: withoutMargin
        }));
        $[34] = clearable;
        $[35] = disabled;
        $[36] = disabledTooltip;
        $[37] = input;
        $[38] = label;
        $[39] = labelIcon;
        $[40] = limit;
        $[41] = loading;
        $[42] = minInputValueLength;
        $[43] = placeholder;
        $[44] = props.allowSelectAll;
        $[45] = props.externalItems;
        $[46] = props.selectAllLabel;
        $[47] = props.type;
        $[48] = renderError;
        $[49] = renderOption;
        $[50] = renderTags;
        $[51] = required;
        $[52] = t8;
        $[53] = t9;
        $[54] = testId;
        $[55] = tooltip;
        $[56] = withoutMargin;
        $[57] = t10;
    } else t10 = $[57];
    return t10;
};
export { MultipleAutocompleteInput_MultipleAutocompleteInput as MultipleAutocompleteInput };
